export const AppConfig = {
  baseUrl: process.env.NEXT_PUBLIC_APP_BASE_URL || 'https://app.capcito.test',
}
